import React, { useMemo } from 'react';
import { Container, Table } from 'reactstrap';
import { reduxForm } from 'redux-form';
import t, { partial } from '../../../util/translation/translation';
import CheckIcon from '../../../shared/components/custom/CheckIcon';
import { formatDate } from '../../../util/date-and-time';

const InvitesCard = ({ invites, participantSearch }) => {
  const s = partial('shared');
  const p = partial('EventParticipantsPage');
  const filteredInvites = useMemo(() => {
    return invites.filter((invite) =>
      invite.email.toLowerCase().includes(participantSearch.toLowerCase())
    );
  }, [invites, participantSearch]);

  const renderInvites = () => {
    const keys = ['email'];
    return filteredInvites
      .filter((participant) =>
        keys.some((key) =>
          participant[key]
            .toLowerCase()
            .includes(participantSearch.toLowerCase())
        )
      )
      .map((participant) => (
        <tr key={`renderParticipants-${participant.id}`}>
          <td>{participant.email}</td>
          <td>
            <td className="flex-Hcenter">
              <CheckIcon state={!!participant.registeredAt} />
            </td>
          </td>
          <td>
            {participant.registeredAt
              ? formatDate(participant.registeredAt)
              : '-'}
          </td>
          <td>{formatDate(participant?.createdAt)}</td>
        </tr>
      ));
  };

  return (
    <Container style={{ padding: 0 }}>
      <div
        style={{
          display: 'flex',
          paddingBottom: 5,
          background: '#fff',
          borderRadius: 6,
          border: '1px solid rgba(0,0,0,0.08)',
        }}
      >
        <Table responsive striped>
          <thead>
            <tr>
              <th>{s('email')}</th>
              <th>{p('hasRegistered')}</th>
              <th>{p('registeredAt')}</th>
              <th>{p('sentAt')}</th>
            </tr>
          </thead>
          <tbody>{renderInvites()}</tbody>
        </Table>
      </div>
    </Container>
  );
};

const reduxF = reduxForm({
  form: 'EventsPariticipantForm',
  enableReinitialize: true,
});

export default reduxF(InvitesCard);
